import React, { useCallback } from 'react'
import '../Inputs.scss'

const NumberInput = ({ children, min, max, handleChange, name, value, onBlur, ...props }: any) => {
  const onChangeHandler = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      handleChange({ value: e.currentTarget.value, name })
    },
    [min, max]
  )

  const onBlurHandler = (e: React.FormEvent<HTMLInputElement>) => {
    if (onBlur) onBlur({ value: e.currentTarget.value, name })
  }

  return (
    <>
      <div className={`number-input`}>
        <div className='number-input__label'>{''}</div>
        <input
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          value={value}
          className={`number-input__input ${false /*label*/ && 'with-label'}`}
          type='number'
        />
        {children}
      </div>
    </>
  )
}

export default NumberInput
